module.exports = __webpack_public_path__ + "img/logo_biotopia_col_white.1e10c72e.png";